const MY_CMS_APPS_URLS = {
  dev: 'https://test2.idp.idm.cms.gov/app/UserHome',
  impl: 'https://impl.idp.idm.cms.gov/app/UserHome',
  prod: 'https://idm.cms.gov/app/UserHome',
  test: 'https://test.idp.idm.cms.gov/app/UserHome',
} as const;

export function getMyCmsAppsUrl(environment = import.meta.env.VITE_ENVIRONMENT): string {
  const normalizedEnvironment = environment?.trim().toLowerCase();

  if (normalizedEnvironment === 'prod' || normalizedEnvironment === 'production') {
    return MY_CMS_APPS_URLS.prod;
  }

  if (normalizedEnvironment === 'impl') {
    return MY_CMS_APPS_URLS.impl;
  }

  if (normalizedEnvironment === 'test') {
    return MY_CMS_APPS_URLS.test;
  }

  return MY_CMS_APPS_URLS.dev;
}

export const MY_CMS_APPS_URL = getMyCmsAppsUrl();
